import { safeParseDate } from './dateUtils.js';

/**
 * The "Afficher" (sense) filter splits issues into flux vs stock subsets.
 * Single source of truth for the predicate, reused by the option-list scoping
 * in GPSContext and by the sense-scoped dataset (gps.sensedIssues).
 *
 *  - received → created within the selected period
 *  - resolved → status_category === 'DONE'
 *  - ongoing  → status_category !== 'DONE'
 *  - all      → everything
 */
export const makeSenseMatcher = (sense, { startDate, endDate } = {}) => {
  switch (sense) {
    case 'received':
      return (issue) => {
        const d = safeParseDate(issue.created);
        return !!d && d >= startDate && d <= endDate;
      };
    case 'resolved':
      return (issue) => issue.status_category === 'DONE';
    case 'ongoing':
      return (issue) => issue.status_category !== 'DONE';
    default:
      return () => true;
  }
};

export const applySense = (issues, sense, dates) =>
  (issues || []).filter(makeSenseMatcher(sense, dates));

// Tabs where the "Afficher" control has an actual effect.
export const SENSE_ACTIVE_TABS = ['general', 'issues'];

export const isSenseActiveForTab = (tab) => SENSE_ACTIVE_TABS.includes(tab);

// Tabs that pin the "Afficher" control to a fixed value (shown but inactive),
// because the tab only makes sense for one subset. Statuts = closed tickets only.
export const SENSE_FORCED_TABS = { statuses: 'resolved' };

export const getForcedSense = (tab) => SENSE_FORCED_TABS[tab] || null;
